<template>
  <form @submit.prevent="handleSubmit">
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Cash Transfer" disabled placeholder="Cash Transfer" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Withdraw From</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="selectedAccountDetails && Number(selectedAccountDetails.trader_type) === 2">
                <fieldset>
                  <legend>Investor Available Withdraw Amount</legend>
                  <v-text-field
                    :value="`${selectedAccountDetails.currency_symbol || '$'} ${selectedAccountDetails.availableWithdraw} ( MAM Profit Amount is ${selectedAccountDetails.profitAmount}$ )`"
                    readonly
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>
              
               <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field v-model="withdrawAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select" min="1" :rules="amountRules" :error="errors.amount" :error-messages="errors.amount ? ['Amount is required'] : []"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Amount in (INR)</legend>
                  <v-text-field readonly v-model="currencyAmount" label="INR" type="number" single-line solo hide-details
                    class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                 <small><v-icon size="17" class="mr-2" color="#039de9">mdi-information-outline</v-icon>OTP Will Send To Your <span v-if="otp_via == 1">Email Address. <small>(In case of failure check Phone no also.)</small></span> <span v-if="otp_via == 2">Phone Number. <small>(In case of failure check Email also.)</small></span> <span v-if="otp_via == 3">Phone Number and Email Address both.</span> </small>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn tile elevation="0" type="submit" class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain" :loading="loading" :disabled="!isFormValid">
                  Withdraw
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>
            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
            <v-card-actions v-if="Number(selectedAccountDetails.trader_type) === 2" class="mt-4">
              <v-alert type="info" dense text class="w-100">
                This is an <strong>Investor Account</strong>. You can withdraw from your <strong>capital only</strong>. 
                Your profit amount of <strong>{{ selectedAccountDetails.profitAmount }}</strong> will be processed by the MAM system.
              </v-alert>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,
      selectedAccount: null,
      withdrawAmount: '',
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#fff"
      },
      errors: {
        account: false,
        amount: false
      },
      loading: false,
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
      amountRules: [
        v => !!v || 'Amount is required',
        v => v > 0 || 'Amount must be greater than 0',
        v => !this.selectedAccountDetails || parseFloat(v) <= this.selectedAccountDetails.MarginFree || 'Amount exceeds available funds',
        v => !this.selectedAccountDetails || this.currencyAmount <= this.selectedAccountDetails.MarginFree || 'Amount exceeds available funds',
      ]
    };
  },

  computed: {
    ...mapState("withdraw", ["accounts",  "inrrate", "otp_via"]),
    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },

    selectedAccountDetails() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
    },

    // isFormValid() {
    //   console.log(this.selectedAccountDetails?.MarginFree)
    //   return this.selectedAccount &&
    //     this.withdrawAmount &&
    //     parseFloat(this.withdrawAmount) > 0 &&
    //     (!this.selectedAccountDetails || this.currencyAmount <= this.selectedAccountDetails.availableMarginFree);
    // }
    isFormValid() {
      return (
        this.selectedAccount &&
        this.withdrawAmount &&
        parseFloat(this.withdrawAmount) > 0 &&
        (!this.selectedAccountDetails || parseFloat(this.withdrawAmount) <= this.selectedAccountDetails.MarginFree)
      );
    }
  },

  watch: {
    // withdrawAmount(newAmount) {
    //   if (this.currency && this.currency.rate) {
    //     this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
    //   } else {
    //     this.currencyAmount = newAmount;
    //   }
    // }
    withdrawAmount(newAmount) {
    if (!newAmount || isNaN(newAmount) || Number(newAmount) <= 0) {
      this.currencyAmount = '';
      return;
    }
    const amt = Number(newAmount);
    const rate = Number(this.inrrate) || 1; 
    this.currencyAmount = (amt * rate).toFixed(2);
  }
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS,
      WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP,
      WITHDRAWMETHODS__ACTIONS.INRRATE,
      WITHDRAWMETHODS__ACTIONS.OTPVIA,
    ]),

    handleAccountChange() {
      this.withdrawAmount = '';
      this.errors.account = false;
      this.currencyAmount = ''; 
      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    async handleSubmit() {
      this.loading = true;

      try {
        const amount = parseFloat(this.withdrawAmount);
        if (isNaN(amount) || amount <= 0) {
          toast.error('Please enter a valid deposit amount');
        }

        await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP]()
        this.$router.push(`/cash-withdraw-otp?payment_id=${this.payment_id}&trading_account_no=${this.selectedAccount}&amount=${this.withdrawAmount}`)
        this.resetForm();
      } catch (error) {
        console.error('Deposit submission error:', error.message);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.selectedAccount = null;
      this.withdrawAmount = '';
    },

    validateForm() {
      this.errors.account = !this.selectedAccount;
      this.errors.amount = !this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0 ||  this.currencyAmount > this.account_details.Balance;
      return !this.errors.account && !this.errors.amount;
    },
  },
  async mounted() {
    await this[WITHDRAWMETHODS__ACTIONS.OTPVIA]();
    this.payment_id = this.$route.query.payment_id;
    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS]();
     await this[WITHDRAWMETHODS__ACTIONS.INRRATE]();
     if (this.inrrate) {
      this.currency.rate = Number(this.inrrate);
       //console.log("INR rate CAS applied:", this.currency.rate);
    } else {
      console.warn("INR rate not found!");
    }
  },
};
</script>
